import { ErrorBoundaryProps } from 'expo-router';
import { Stack } from 'expo-router';
import { View, Text, TouchableOpacity } from 'react-native';
import * as Sentry from '@sentry/react-native';

Sentry.init({
  dsn: 'https://3e0e7d1f407aff8922fba64e48022ae0@o4511420665692160.ingest.us.sentry.io/4511420706586624',

  // Adds more context data to events (IP address, cookies, user, etc.)
  // For more information, visit: https://docs.sentry.io/platforms/react-native/data-management/data-collected/
  sendDefaultPii: true,

  // Enable Logs
  enableLogs: true,

  // Configure Session Replay
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 0.0,
  // integrations: [Sentry.mobileReplayIntegration()],

  // uncomment the line below to enable Spotlight (https://spotlightjs.com)
  // spotlight: __DEV__,
});

export function ErrorBoundary({ error, retry }: ErrorBoundaryProps) {
  return (
    <View style={{ flex: 1, backgroundColor: '#fff', padding: 40, justifyContent: 'center', alignItems: 'center' }}>
      <Text style={{ fontSize: 40, marginBottom: 20 }}>⚠️</Text>
      <Text style={{ fontSize: 24, fontWeight: '700', color: '#333', marginBottom: 10, textAlign: 'center' }}>
        Oops! Something went wrong.
      </Text>
      <Text style={{ fontSize: 14, color: '#666', textAlign: 'center', lineHeight: 20 }}>
        {error.message}
      </Text>
      <TouchableOpacity
        onPress={retry}
        style={{ marginTop: 30, backgroundColor: '#333', paddingVertical: 12, paddingHorizontal: 30, borderRadius: 25 }}
      >
        <Text style={{ color: '#fff', fontWeight: '600' }}>Try Again</Text>
      </TouchableOpacity>
    </View>
  );
}

export default Sentry.wrap(function RootLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen
        name="terms"
        options={{
          presentation: 'transparentModal',
          animation: 'fade',
        }}
      />
      <Stack.Screen
        name="privacy"
        options={{
          presentation: 'transparentModal',
          animation: 'fade',
        }}
      />
      <Stack.Screen
        name="packs"
        options={{
          presentation: 'transparentModal',
          animation: 'fade',
        }}
      />
    </Stack>
  );
});